import React from 'react';

import PropTypes from 'prop-types';

import { SIDE_PANEL_CONTENT } from './constants';
import { OrderSummary } from './order-summary';
import { ReturnsPanel } from './returns/returns-panel';
import { ShipmentsPanel } from './shipments/shipments-panel';

import style from './side-panel.module.less';

const sidePanelContentMap = {
  [SIDE_PANEL_CONTENT.NONE]: null,
  [SIDE_PANEL_CONTENT.ORDER_SUMMARY]: <OrderSummary />,
  [SIDE_PANEL_CONTENT.SHIPMENTS]: <ShipmentsPanel />,
  [SIDE_PANEL_CONTENT.RETURNS]: <ReturnsPanel />,
};

const PADDED_SIDE_PANELS = [SIDE_PANEL_CONTENT.SHIPMENTS, SIDE_PANEL_CONTENT.RETURNS];

export const SidePanel = ({ selectedViewId }) => {
  const sidePanelContent = sidePanelContentMap[selectedViewId];
  const isPaddedSidePanel = PADDED_SIDE_PANELS.includes(selectedViewId);

  if (!sidePanelContent) {
    return null;
  }

  return (
    <div className={isPaddedSidePanel ? style['order-details-padded-side-panel'] : style['order-details-side-panel']}>
      {sidePanelContent}
    </div>
  );
};

SidePanel.propTypes = {
  selectedViewId: PropTypes.oneOf(Object.values(SIDE_PANEL_CONTENT)).isRequired,
};
